import { memo } from 'react';
import { bool, shape, string } from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import classnames from 'classnames';

import { triggerEditPageClickedAnalytics } from '~/analytics/analytics.listener';
import { Button, Section, Title } from '~/elements';

import { PATH_NAMES } from '../../../../constants';

import { PersonDetailsCard } from './person-details-card';
import { PersonDetailsList } from './person-details-list';
import {
  selectAttendeeDetails,
  selectAppointmentForSomeoneElseAnswer,
  selectAppointmentGiftAnswer,
  selectUserDetails,
} from '../../selectors';

import styles from './YourDetails.scss';

export const YourDetails = ({
  yourDetails,
  isAppointmentForSomeoneElse = false,
  isAppointmentGift = false,
  attendeeDetails,
  history,
}) => (
  <Section className={styles.YourDetailsSection} data-testid="YourDetails">
    <Title className={classnames(styles.SectionTitle)} data-testid="YourDetailsTitle">
      Booking details
      <Button
        view="underlined"
        onClick={() => {
          triggerEditPageClickedAnalytics('details');
          history.pushWithToken(PATH_NAMES.EDIT_YOUR_DETAILS);
        }}
      >
        Edit
      </Button>
    </Title>
    {isAppointmentForSomeoneElse ? (
      <div className={styles.YourDetailsGrid}>
        <div className={styles.YourDetailsCol}>
          <PersonDetailsCard
            title="Your details"
            data-testid="PersonalDetailsData"
            {...yourDetails}
          />
        </div>
        <div className={styles.YourDetailsCol}>
          {isAppointmentGift ? (
            <PersonDetailsCard
              title="Appointment is a gift for"
              data-testid="AttendeeDetailsData"
              {...attendeeDetails}
            />
          ) : (
            <PersonDetailsCard
              title="Details of person attending"
              data-testid="AttendeeDetailsData"
              {...attendeeDetails}
            />
          )}
        </div>
      </div>
    ) : (
      <PersonDetailsList data-testid="PersonalDetailsData" {...yourDetails} />
    )}
  </Section>
);

YourDetails.propTypes = {
  yourDetails: shape({
    name: string.isRequired,
    phone: string.isRequired,
    email: string.isRequired,
  }).isRequired,
  history: shape({}).isRequired,
  attendeeDetails: shape({
    name: string.isRequired,
    phone: string.isRequired,
  }),
  isAppointmentForSomeoneElse: bool,
  isAppointmentGift: bool,
};

const mapStateToProps = createStructuredSelector({
  attendeeDetails: selectAttendeeDetails,
  isAppointmentForSomeoneElse: selectAppointmentForSomeoneElseAnswer,
  isAppointmentGift: selectAppointmentGiftAnswer,
  yourDetails: selectUserDetails,
});

export const ConnectedYourDetails = withRouter(connect(mapStateToProps)(memo(YourDetails)));
